// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"AddParameterButton__wrapper___2nFG7","button":"AddParameterButton__button___1ALEV"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PatchParameters/AddParameterButton/AddParameterButton.css
// module id = 356
// module chunks = 0